"use client";

import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { Carousel, CarouselApi, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VoicesOfBeauty() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  const testimonials = [{
    quote: "Joanne transformed my vision into reality. I felt like the most radiant version of myself on my wedding day.",
    author: "Elena R.",
    position: "Bridal Client, 2023",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/bride_portrait_soft.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/bride_portrait_soft.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/bride_portrait_soft.png-wvc-sizes"
  }, {
    quote: "Her editorial eye is unmatched. The makeup was flawless, high-definition, and lasted through the entire shoot.",
    author: "Sarah M.",
    position: "Editorial Model, 2024",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/editorial_model_portrait.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/editorial_model_portrait.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/editorial_model_portrait.png-wvc-sizes"
  }, {
    quote: "I learned so much during my private lesson. Joanne’s technique is organic, luxurious, and so easy to replicate.",
    author: "Chloe T.",
    position: "Makeup Lesson Student, 2024",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/student_portrait_glow.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/student_portrait_glow.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/student_portrait_glow.png-wvc-sizes"
  }, {
    quote: "Professional, calm, and incredibly talented. She made our entire bridal party feel like royalty.",
    author: "Jessica L.",
    position: "Bridal Client, 2024",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/bridal_party_portrait.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/bridal_party_portrait.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/bridal_party_portrait.png-wvc-sizes"
  }];
  const romanNumerals = ["I", "II", "III", "IV"];
  useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  return <section data-section-id="1048" id="voices-of-beauty" className="relative bg-background text-foreground py-28 md:py-40 overflow-hidden">
      <div className="container mx-auto px-5 md:px-8">
        <div ref={ref} className={`max-w-[880px] mx-auto transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {}
          <div className="flex flex-col items-center text-center">
            <span className="font-default text-xs uppercase tracking-[0.18em] leading-none" style={{
            color: "var(--muted-foreground)"
          }}>TESTIMONIALS / CLIENT EXPERIENCES</span>

            {}
            <div className="flex items-center justify-center mt-6 w-full max-w-[280px]">
              <div className="flex-1 h-px" style={{
              backgroundColor: "var(--border)"
            }} />
              <svg width="32" height="16" viewBox="0 0 32 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-2">
                <path d="M2 8 Q 8 8 16 8 Q 24 8 30 8" stroke="var(--primary)" strokeWidth="1.25" strokeLinecap="round" />
                <path d="M10 8 Q 12 4 14 6" stroke="var(--primary)" strokeWidth="1.25" strokeLinecap="round" fill="none" />
                <path d="M16 8 Q 18 12 20 10" stroke="var(--primary)" strokeWidth="1.25" strokeLinecap="round" fill="none" />
                <path d="M22 8 Q 24 4 26 6" stroke="var(--primary)" strokeWidth="1.25" strokeLinecap="round" fill="none" />
              </svg>
              <div className="flex-1 h-px" style={{
              backgroundColor: "var(--border)"
            }} />
            </div>

            {}
            <div className="relative mt-8">
              <span aria-hidden="true" className="pointer-events-none select-none absolute font-serif italic font-normal -top-10 md:-top-14 left-1/2 -translate-x-1/2" style={{
              color: "var(--primary)",
              opacity: 0.08,
              fontSize: "clamp(8rem, 16vw, 14rem)",
              lineHeight: 1
            }}>
                G
              </span>
              <h2 className="font-default font-serif relative font-normal tracking-tight leading-[1.02]" style={{
              color: "var(--foreground)",
              fontSize: "clamp(2.25rem, 4.6vw, 4rem)",
              fontWeight: 420
            }}>
                Radiant{" "}
                <span className="italic" style={{
                color: "var(--primary)"
              }}>
                  Testimonials
                </span>
              </h2>
            </div>
          </div>

          {}
          <div className="relative mt-16 md:mt-20">
            <Carousel setApi={setApi} opts={{
            loop: true,
            align: "start"
          }} className="w-full">
              <CarouselContent>
                {testimonials.map((t, i) => <CarouselItem key={i} data-index={i}>
                    <div className="flex flex-col items-center text-center px-2 md:px-12">
                      {}
                      <div className="flex items-center gap-1.5 mb-8">
                        {Array.from({
                      length: 5
                    }).map((_, s) => <Star key={s} className="size-4" strokeWidth={1.5} style={{
                      color: "var(--primary)"
                    }} />)}
                      </div>

                      {}
                      <blockquote className="font-serif italic font-normal max-w-[720px]" style={{
                    color: "var(--foreground)",
                    fontSize: "clamp(1.15rem, 2vw, 1.5rem)",
                    lineHeight: 1.4
                  }}>
                        "{t.quote}"
                      </blockquote>

                      {}
                      <div className="flex items-center justify-center mt-10 w-full max-w-[200px]">
                        <div className="flex-1 h-px" style={{
                      backgroundColor: "var(--border)"
                    }} />
                        <div className="size-1 rounded-lg mx-2" style={{
                      backgroundColor: "var(--primary)"
                    }} />
                        <div className="flex-1 h-px" style={{
                      backgroundColor: "var(--border)"
                    }} />
                      </div>

                      {}
                      <div className="flex items-center gap-4 mt-8">
                        {}
                        <div className="relative">
                          <div className="absolute inset-0 rounded-lg" style={{
                        border: "1px solid var(--primary)",
                        transform: "scale(1.16)",
                        opacity: 0.5
                      }} />
                          <div className="size-12 rounded-lg overflow-hidden" style={{
                        border: "1px solid var(--primary)",
                        borderRadius: "0px"
                      }}>
                            <img src={t.image} data-wvc-srcset={t.srcset} data-wvc-sizes={t.sizes} alt={t.author} loading="lazy" decoding="async" className="w-full h-full object-cover" style={{
                          borderRadius: "0px"
                        }} />
                          </div>
                        </div>
                        <div className="flex flex-col items-start text-left">
                          <span className="font-default text-sm font-semibold" style={{
                        color: "var(--foreground)"
                      }}>
                            {t.author}
                          </span>
                          <span className="font-default text-xs tracking-wider mt-0.5" style={{
                        color: "var(--muted-foreground)"
                      }}>
                            {t.position}
                          </span>
                        </div>
                      </div>
                    </div>
                  </CarouselItem>)}
              </CarouselContent>
            </Carousel>

            {}
            <Button variant="ghost" size="icon" onClick={() => api?.scrollPrev()} aria-label="Previous testimonial" className="hidden md:flex absolute top-1/2 -translate-y-1/2 -left-4 lg:-left-16 size-12 rounded-lg items-center justify-center bg-transparent hover:bg-transparent" style={{
            border: "1px solid var(--primary)",
            color: "var(--primary)",
            borderRadius: "0px"
          }}>
              <span className="font-serif italic text-xl leading-none">←</span>
            </Button>
            <Button variant="ghost" size="icon" onClick={() => api?.scrollNext()} aria-label="Next testimonial" className="hidden md:flex absolute top-1/2 -translate-y-1/2 -right-4 lg:-right-16 size-12 rounded-lg items-center justify-center bg-transparent hover:bg-transparent" style={{
            border: "1px solid var(--primary)",
            color: "var(--primary)",
            borderRadius: "0px"
          }}>
              <span className="font-serif italic text-xl leading-none">→</span>
            </Button>
          </div>

          {}
          <div className="flex md:hidden items-center justify-center gap-6 mt-10">
            <Button variant="ghost" size="icon" onClick={() => api?.scrollPrev()} aria-label="Previous testimonial" className="size-12 rounded-lg bg-transparent hover:bg-transparent" style={{
            border: "1px solid var(--primary)",
            color: "var(--primary)",
            borderRadius: "0px"
          }}>
              <span className="font-serif italic text-xl leading-none">←</span>
            </Button>
            <Button variant="ghost" size="icon" onClick={() => api?.scrollNext()} aria-label="Next testimonial" className="size-12 rounded-lg bg-transparent hover:bg-transparent" style={{
            border: "1px solid var(--primary)",
            color: "var(--primary)",
            borderRadius: "0px"
          }}>
              <span className="font-serif italic text-xl leading-none">→</span>
            </Button>
          </div>

          {}
          <div className="flex items-center justify-center gap-3 mt-10">
            {Array.from({
            length: count
          }).map((_, i) => <Button key={i} data-index={i} onClick={() => api?.scrollTo(i)} variant="ghost" size="sm" aria-label={`Go to slide ${i + 1}`} className="font-default text-sm tracking-wider transition-opacity duration-300 px-1 h-auto p-0 bg-transparent hover:bg-transparent" style={{
            color: "var(--primary)",
            opacity: current === i ? 1 : 0.35
          }}>
                {romanNumerals[i]}
                {i < count - 1 && <span className="ml-3" style={{
              color: "var(--muted-foreground)",
              opacity: 0.5
            }}>
                    ·
                  </span>}
              </Button>)}
          </div>
        </div>
      </div>
    </section>;
}